// @ts-nocheck
export const localeCodes =  [
  "de",
  "en",
  "es",
  "fr",
  "id",
  "it",
  "ja",
  "ko",
  "pl",
  "pt",
  "ru",
  "tr",
  "uk",
  "zh"
]
export const localeLoaders = {
  de: [
    {
      key: "locale_de_46json_5d6b188e",
      load: () => import("#nuxt-i18n/5d6b188e" /* webpackChunkName: "locale_de_46json_5d6b188e" */),
      cache: true
    }
  ],
  en: [
    {
      key: "locale_en_46json_7a337b0b",
      load: () => import("#nuxt-i18n/7a337b0b" /* webpackChunkName: "locale_en_46json_7a337b0b" */),
      cache: true
    }
  ],
  es: [
    {
      key: "locale_es_46json_13676751",
      load: () => import("#nuxt-i18n/13676751" /* webpackChunkName: "locale_es_46json_13676751" */),
      cache: true
    }
  ],
  fr: [
    {
      key: "locale_fr_46json_c48dae51",
      load: () => import("#nuxt-i18n/c48dae51" /* webpackChunkName: "locale_fr_46json_c48dae51" */),
      cache: true
    }
  ],
  id: [
    {
      key: "locale_id_46json_6e639941",
      load: () => import("#nuxt-i18n/6e639941" /* webpackChunkName: "locale_id_46json_6e639941" */),
      cache: true
    }
  ],
  it: [
    {
      key: "locale_it_46json_c03922f9",
      load: () => import("#nuxt-i18n/c03922f9" /* webpackChunkName: "locale_it_46json_c03922f9" */),
      cache: true
    }
  ],
  ja: [
    {
      key: "locale_ja_46json_ee24f195",
      load: () => import("#nuxt-i18n/ee24f195" /* webpackChunkName: "locale_ja_46json_ee24f195" */),
      cache: true
    }
  ],
  ko: [
    {
      key: "locale_ko_46json_605307c0",
      load: () => import("#nuxt-i18n/605307c0" /* webpackChunkName: "locale_ko_46json_605307c0" */),
      cache: true
    }
  ],
  pl: [
    {
      key: "locale_pl_46json_b459e583",
      load: () => import("#nuxt-i18n/b459e583" /* webpackChunkName: "locale_pl_46json_b459e583" */),
      cache: true
    }
  ],
  pt: [
    {
      key: "locale_pt_46json_204682e6",
      load: () => import("#nuxt-i18n/204682e6" /* webpackChunkName: "locale_pt_46json_204682e6" */),
      cache: true
    }
  ],
  ru: [
    {
      key: "locale_ru_46json_69325769",
      load: () => import("#nuxt-i18n/69325769" /* webpackChunkName: "locale_ru_46json_69325769" */),
      cache: true
    }
  ],
  tr: [
    {
      key: "locale_tr_46json_eb2b6536",
      load: () => import("#nuxt-i18n/eb2b6536" /* webpackChunkName: "locale_tr_46json_eb2b6536" */),
      cache: true
    }
  ],
  uk: [
    {
      key: "locale_uk_46json_be66b0eb",
      load: () => import("#nuxt-i18n/be66b0eb" /* webpackChunkName: "locale_uk_46json_be66b0eb" */),
      cache: true
    }
  ],
  zh: [
    {
      key: "locale_zh_46json_7264fb95",
      load: () => import("#nuxt-i18n/7264fb95" /* webpackChunkName: "locale_zh_46json_7264fb95" */),
      cache: true
    }
  ]
}
export const vueI18nConfigs = [
  () => import("#nuxt-i18n/6daef7fe" /* webpackChunkName: "config_i18n_46config_46ts_6daef7fe" */)
]
export const normalizedLocales = [
  {
    code: "de",
    language: "de-DE",
    name: "Deutsch",
    _hreflang: "de-DE",
    _sitemap: "de-DE"
  },
  {
    code: "en",
    language: "en-US",
    name: "English",
    _hreflang: "en-US",
    _sitemap: "en-US"
  },
  {
    code: "es",
    language: "es-ES",
    name: "Español",
    _hreflang: "es-ES",
    _sitemap: "es-ES"
  },
  {
    code: "fr",
    language: "fr-FR",
    name: "Français",
    _hreflang: "fr-FR",
    _sitemap: "fr-FR"
  },
  {
    code: "id",
    language: "id-ID",
    name: "Bahasa Indonesia",
    _hreflang: "id-ID",
    _sitemap: "id-ID"
  },
  {
    code: "it",
    language: "it-IT",
    name: "Italiano",
    _hreflang: "it-IT",
    _sitemap: "it-IT"
  },
  {
    code: "ja",
    language: "ja-JP",
    name: "日本語",
    _hreflang: "ja-JP",
    _sitemap: "ja-JP"
  },
  {
    code: "ko",
    language: "ko-KR",
    name: "한국어",
    _hreflang: "ko-KR",
    _sitemap: "ko-KR"
  },
  {
    code: "pl",
    language: "pl-PL",
    name: "Polski",
    _hreflang: "pl-PL",
    _sitemap: "pl-PL"
  },
  {
    code: "pt",
    language: "pt-PT",
    name: "Português",
    _hreflang: "pt-PT",
    _sitemap: "pt-PT"
  },
  {
    code: "ru",
    language: "ru-RU",
    name: "Русский",
    _hreflang: "ru-RU",
    _sitemap: "ru-RU"
  },
  {
    code: "tr",
    language: "tr-TR",
    name: "Türkçe",
    _hreflang: "tr-TR",
    _sitemap: "tr-TR"
  },
  {
    code: "uk",
    language: "uk-UA",
    name: "Українська",
    _hreflang: "uk-UA",
    _sitemap: "uk-UA"
  },
  {
    code: "zh",
    language: "zh-CN",
    name: "中文",
    _hreflang: "zh-CN",
    _sitemap: "zh-CN"
  }
]
/** client **/

/** client-end **/